import { appointmentService } from "@features/appointment/appointmentService";
import { Appointment, AppointmentAvailability } from "@features/appointment/types";
import createEntitySlice from "@services/createEntitySlice";
import { createAsyncThunk } from "@reduxjs/toolkit";

// Ação para buscar a disponibilidade de um agendamento
export const fetchAppointmentAvailability = createAsyncThunk(
  "appointment/fetchAvailability",
  async (appointmentId: string, { rejectWithValue }) => {
    try {
      const response = await appointmentService.getAvailability(appointmentId);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

const {
  reducer: appointmentReducer,
  actions: appointmentActions,
  fetchAll: fetchAppointments,
  fetchById: fetchAppointmentById,
  createEntity: createAppointment,
  updateEntity: updateAppointment,
  deleteEntity: deleteAppointment,
} = createEntitySlice<Appointment>("appointment", appointmentService);

export {
  appointmentReducer,
  appointmentActions,
  fetchAppointments,
  fetchAppointmentById,
  createAppointment,
  updateAppointment,
  deleteAppointment,
}; 